<div class="shell">
  <!-- TOP BAR -->
  <header class="topbar">
    <button type="button" class="hamburger" (click)="toggleSidebar()" aria-label="Menu" [attr.aria-expanded]="sidebarOpen()">☰</button>

    <a class="topbar__brand" routerLink="/visao-geral" (click)="closeSidebar()" aria-label="Unblock It — ir para a Visão geral" title="Ir para o início">
      @if (isLight()) {
        <img class="topbar__logo" src="assets/logo-unblockit-light.webp" alt="Unblock It" />
      } @else {
        <img class="topbar__logo" src="assets/logo-unblockit-dark.webp" alt="Unblock It" />
      }
    </a>

    <button
      type="button"
      class="search"
      (click)="openPalette()"
      aria-haspopup="dialog"
      aria-label="Buscar página, documentação ou ação (atalho: Ctrl mais K)"
      title="Buscar — ⌘K"
    >
      <span class="search__icon" aria-hidden="true">⌕</span>
      <span class="search__placeholder">Buscar página, documentação, ação…</span>
      <span class="search__kbd mono">⌘K</span>
    </button>

    <div class="spacer"></div>

    <button
      type="button"
      class="search-mobile"
      (click)="openPalette()"
      aria-haspopup="dialog"
      aria-label="Buscar página, documentação ou ação"
      title="Buscar"
    >
      <span aria-hidden="true">⌕</span>
    </button>

    <div class="theme-toggle" role="group" aria-label="Tema">
      <button type="button" class="seg" [class.is-on]="isLight()" [attr.aria-pressed]="isLight()" (click)="setLight()" title="Tema claro" aria-label="Tema claro">☀</button>
      <button type="button" class="seg" [class.is-on]="!isLight()" [attr.aria-pressed]="!isLight()" (click)="setDark()" title="Tema escuro" aria-label="Tema escuro">☾</button>
    </div>

    <div class="divider"></div>

    <div class="user-wrap" (click)="$event.stopPropagation()">
      <button
        type="button"
        class="user"
        (click)="toggleUserMenu()"
        aria-haspopup="menu"
        [attr.aria-expanded]="userMenuOpen()"
        aria-label="Menu da conta"
      >
        <span class="user__avatar">{{ user()?.initials || '·' }}</span>
        <div class="user__meta">
          <div class="user__name">{{ user()?.name || 'Carregando…' }}</div>
          <div class="user__role">{{ user()?.email }}</div>
        </div>
        <span class="user__caret" aria-hidden="true">▾</span>
      </button>

      @if (userMenuOpen()) {
        <div class="user-menu" role="menu">
          <a class="user-menu__item" role="menuitem" routerLink="/configuracoes" (click)="closeUserMenu()">
            <span class="user-menu__icon" aria-hidden="true">⚙</span>Configurações
          </a>
          <button type="button" class="user-menu__item" role="menuitem" (click)="logout()">
            <span class="user-menu__icon" aria-hidden="true">⏻</span>Sair
          </button>
        </div>
      }
    </div>
  </header>

  <!-- BODY -->
  <div class="body">
    <!-- Overlay do drawer (mobile) -->
    <div class="sidebar-overlay" [class.is-visible]="sidebarOpen()" (click)="closeSidebar()" aria-hidden="true"></div>

    <!-- SIDEBAR -->
    <nav class="sidebar ub-scroll" [class.is-open]="sidebarOpen()" aria-label="Navegação principal">
      @for (group of visibleNav(); track group.title) {
        <div class="nav-group">{{ group.title }}</div>
        @for (item of group.items; track item.label) {
          @if (item.disabled) {
            <div class="nav-item nav-item--disabled" aria-disabled="true">
              <span class="nav-item__icon">{{ item.icon }}</span>{{ item.label }}
              @if (item.badge) {
                <span class="nav-item__badge mono">{{ item.badge }}</span>
              }
            </div>
          } @else {
            <a class="nav-item" [routerLink]="item.route" routerLinkActive="is-active" (click)="closeSidebar()">
              <span class="nav-item__icon">{{ item.icon }}</span>{{ item.label }}
              @if (item.badge) {
                <span class="nav-item__badge mono">{{ item.badge }}</span>
              }
            </a>
          }
        }
      }

      <div class="sidebar-card">
        <div class="sidebar-card__title">Janela de opção 2027</div>
        <div class="sidebar-card__sub">1 a 30 de setembro de 2026</div>
        <div
          class="sidebar-card__bar"
          role="progressbar"
          aria-label="Progresso até a janela de opção"
          aria-valuemin="0"
          aria-valuemax="100"
          aria-valuenow="40"
        >
          <span style="width: 40%"></span>
        </div>
      </div>
    </nav>

    <!-- CONTENT -->
    <main class="content ub-scroll">
      <router-outlet />
    </main>
  </div>

  @if (paletteOpen()) {
    <ub-command-palette (close)="closePalette()" />
  }

  <ub-toast />
</div>
